//import {} from './/index.js';

export const materials = {
  ReadyNodeMaterials: {},
};
